(function () {
  function openFitChat(trigger) {
    var productTitle = trigger.dataset.klaimProductTitle || 'this product';
    var message = 'Hi, I need sizing advice for ' + productTitle + '.';

    function openWidget() {
      if (!window.GorgiasChat) return;
      window.GorgiasChat.open();
      if (typeof window.GorgiasChat.setCurrentInput === 'function') {
        window.GorgiasChat.setCurrentInput(message);
      }
    }

    if (window.GorgiasChat) {
      Promise.resolve(window.GorgiasChat.init()).then(openWidget);
      return;
    }

    window.addEventListener('gorgias-widget-loaded', function () {
      Promise.resolve(window.GorgiasChat.init()).then(openWidget);
    }, { once: true });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaim-open-gorgias]');
    if (!trigger) return;
    event.preventDefault();
    openFitChat(trigger);
  });
})();
